import {createSlice} from "@reduxjs/toolkit";

const initialState = {
    blackBackground: false,
    visibleSelectTestTypeModal: false,
    managerSelected: 0,
}

const applicationSlice = createSlice({
        name: '@@application',
        initialState: initialState,
        reducers: {
            setBlackBackground:(state, action)=>{

                state.blackBackground = action.payload;
            },
            setVisibleSelectTestTypeModal:(state, action)=>{
                state.visibleSelectTestTypeModal = action.payload;
            },
            setManagerSelected:(state, action)=>{
                state.managerSelected = action.payload;
            },

        },
    }
)

export const {setConfirmModal, setBlackBackground, setVisibleSelectTestTypeModal, setManagerSelected} = applicationSlice.actions;
export const applicationReducer = applicationSlice.reducer;
export const getBlackBackground = (state) => state.application.blackBackground
export const getManagerSelected = (state) => state.application.managerSelected
export const getVisibleSelectTestTypeModal = (state) => state.application.visibleSelectTestTypeModal